import axios from '../../script/axiosAMS'

export default {
  /**
   * 공지사항 조회
   *  noticePid   공지사항 개별 조회. 해당 파라미터가 있으면 다른 파라미터는 무시한다.
   *  showPopup   팝업으로 보여질 공지사항 조회. 해당 파라미터가 있으면 다른 파라미터는 무시한다. showPopup이 true인 공지사항 중 최신 공지사항부터 size 만큼 조회한다. size는 필수 파라미터이다.
   *  page        공지사항 리스트 조회시 설정. 기본값은 1
   *  size        공지사항 리스트 조회시 설정. 팝업 대상 조회시에는 필수값으로 사용. 기본값은 10
   */
  getNotice (params, resultCallback) {
    axios.requestWith({
      url: '/api/notice',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  /**
   * 공지사항 등록
   *   subject    공지사항 제목. 필수
   *   content    공지사항 내용. 필수
   *   showPopup  공지사항 팝업 여부. 설정하지 않으면 false 로 처리한다.
   */
  putNotice (method, data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/notice',
      method: method,
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  /**
   * 공지사항 타이틀, 내용, 팝업 여부 수정
   *  noticePid   업데이트 할 공지사항 pid
   *  subject     공지사항 제목. 설정하지 않으면 기존 제목 유지
   *  content     공지사항 내용. 설정하지 않으면 기존 내용 유지
   *  showPopup   공지사항 팝업 여부. 설정하지 않으면 기존 팝업 여부 유지
   */
  postNotice (method, data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/notice',
      method: method,
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  /**
   * 공지사항 삭제
   *  noticePid   삭제할 공지사항 pid
   */
  deleteNotice (method, data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/notice',
      method: method,
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/notice/notice.js